
import ScenicList from './src/scenic/ScenicList.vue' //景区运营列表
import ScenicAdd from './src/scenic/ScenicAdd.vue' //景区运营添加
import EntertainmentList from './src/entertainment/EntertainmentList.vue' //娱乐场所运营列表
import EntertainmentAdd from './src/entertainment/EntertainmentAdd.vue' //娱乐场所运营添加
import HomestayList from './src/homestay/HomestayList.vue' //民宿运营列表
import HomestayAdd from './src/homestay/HomestayAdd.vue' //民宿运营添加
import ParkList from './src/park/ParkList.vue' //停车场运营列表
import ParkAdd from './src/park/ParkAdd.vue' //停车场运营添加
import HotelList from './src/hotel/HotelList.vue' //酒店运营列表
import HotelAdd from './src/hotel/HotelAdd.vue' //酒店运营添加
import RestaurantList from './src/restaurant/RestaurantList.vue' //饭店运营列表
import RestaurantAdd from './src/restaurant/RestaurantAdd.vue' //饭店运营添加
import TravelList from './src/travel/TravelList.vue' //旅行社运营列表
import TravelAdd from './src/travel/TravelAdd.vue' //旅行社运营添加
import CompanyList from './src/company/CompanyList.vue' //产业基础信息列表
import CompanyAdd from './src/company/CompanyAdd.vue' //产业基础信息添加
import CompanyParkList from './src/company/CompanyParkList.vue' //停车场管理信息列表
import CompanyParkAdd from './src/company/CompanyParkAdd.vue' //停车场信息管理添加
import ShoppingList from './src/shopping/ShoppingList.vue' //购物运营列表
import ShoppingAdd from './src/shopping/ShoppingAdd.vue' //购物运营添加
import TravelCarList from './src/travelCar/TravelCarList.vue' //旅游汽车运营列表
import TravelCarAdd from './src/travelCar/TravelCarAdd.vue' //旅游汽车运营添加
import CompanyToiletList from './src/company/CompanyToiletList.vue' //旅游厕所信息列表
import CompanyToiletAdd from './src/company/CompanyToiletAdd.vue' //旅游厕所信息管理添加

import SecurityList from './src/security/SecurityList.vue' //旅游厕所信息列表
import SecurityAdd from './src/security/SecurityAdd.vue' //旅游厕所信息管理添加

let views = {
  ScenicList,
  ScenicAdd,
  EntertainmentList,
  EntertainmentAdd,
  HomestayList,
  HomestayAdd,
  ParkList,
  ParkAdd,
  HotelList,
  HotelAdd,
  RestaurantList,
  RestaurantAdd,
  TravelList,
  TravelAdd,
  CompanyList,
  CompanyAdd,
  CompanyParkList,
  CompanyParkAdd,
  ShoppingList,
  ShoppingAdd,
  TravelCarList,
  TravelCarAdd,
  CompanyToiletList,
  CompanyToiletAdd,
  SecurityList,
  SecurityAdd
};

export default views;